module.exports = __webpack_public_path__ + "static/media/IMG_20190130_113336908.749a4f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_113336908.jpg
// module id = 48
// module chunks = 0